/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconMinusFilled extends React.Component {
  render() {
    const iconClasses = classNames(
      "icon minus icon-filled",
      this.props.className
    );

    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M21,16H9c-0.552,0-1-0.447-1-1 s0.448-1,1-1h12c0.552,0,1,0.447,1,1S21.552,16,21,16z" />
      </svg>
    );
  }
}

IconMinusFilled.defaultProps = {
  className: null
};

IconMinusFilled.propTypes = {
  className: PropTypes.string
};

export default IconMinusFilled;
